<template>
  <div>
    <div class="card-spacing" />

    <welcome-card
      :button-route="{name: 'create_account'}"
      :button-text="$t('cms.login.GoToSignup')"
    />

    <div class="card-spacing" />

    <carousel
      :value="slide"
      :per-page="1"
      :center-mode="true"
      :navigation-enabled="false"
      :touch-drag="false"
      :mouse-drag="false"
      :pagination-enabled="false"
      :speed="200"
      :navigate-to="carouselIndex"
    >
      <slide>
        <form class="card flex column mb1" @submit.prevent="submitLogin">
          <card-header
            :title="$t('cms.login.LoginHeader')"
            :description="$t('cms.campaign.LoginDescription')"
            :hasInfoIcon="false"
            :hasCheckMark="false"
          >
            <template #icon>
              <icon login xlarge />
            </template>
          </card-header>

          <div class="pa2 flex column">
            <input
              type="email"
              v-model="email"
              name="email"
              :placeholder="$t('cms.login.EmailPlaceholder')"
              v-validate="'required|email'"
              class="flex grow box center_text my1"
            >

            <input
              type="password"
              v-model="password"
              name="password"
              :placeholder="$t('cms.login.PasswordPlaceholder')"
              v-validate="forgotPassword ? '' : 'required'"
              class="flex grow box center_text my1"
            >

            <button
              :disabled="!(validEmail && password && !errors.has('password'))"
              style="height: 40px"
              class="flex grow black_background white box my1"
            >
              <b>{{ $t('cms.login.LoginButton') }}</b>
            </button>

            <span @click="forgotPassword = !forgotPassword" class="bold small action mr0 mla mt1">
              {{ $t('cms.login.ForgotPassword') }}
            </span>
          </div>
        </form>
      </slide>

      <slide>
        <form
          class="card flex column"
          @submit.prevent="requestNewPassword"
          novalidate
        >
          <card-header
            :title="$t('cms.login.ForgotPasswordHeader')"
            :description="$t('cms.campaign.ForgotPasswordDescription')"
            :hasInfoIcon="false"
            :hasCheckMark="false"
          >
            <template #icon>
              <icon reset-pass xlarge />
            </template>
          </card-header>

          <div class="pa2 flex column">

            <input
              type="email"
              v-model="email"
              name="email"
              :placeholder="$t('cms.resetpassword.EmailPlaceholder')"
              v-validate="'required|email'"
              class="flex grow box center_text my1"
            >

            <button
              :disabled="!validEmail"
              style="height: 40px"
              class="flex grow secondary_background white box my1"
            >
              <b>{{ $t('cms.resetpassword.RequestPasswordButton') }}</b>
            </button>

            <span @click="forgotPassword = false" class="bold small action mr0 mla mt1">
            {{ $t('cms.resetpassword.GoToLogin') }}
            </span>
          </div>
        </form>
      </slide>

      <slide>
        <div class="card flex column">
          <h1 class="center_text medium my4">
            {{ $t('cms.resetpassword.LinkHasBeenSentTo') }}{{ email }}
          </h1>

          <span @click="reset" class="bold small action mr0 mla mt1">
          {{ $t('cms.resetpassword.GoToLogin') }}
        </span>
        </div>
      </slide>
    </carousel>

    <div class="card-spacing" />

  </div>
</template>

<script>
import AuthMixin from '@/mixins/auth_mixin';
import CarouselMixin from '@/mixins/carousel_mixin';
import WelcomeCard from '@/components/WelcomeCard.vue';
import CardHeader from '@/components/global/CardHeader.vue';

export default {
  name: 'login',

  components: { CardHeader, WelcomeCard },

  mixins: [AuthMixin, CarouselMixin],

  data() {
    return {
      email: null,
      password: null,
      forgotPassword: false,
      passwordRequested: false,
    };
  },

  computed: {
    validEmail() {
      return this.email && !this.errors.has('email');
    },

    slide() {
      if (this.passwordRequested) {
        return 2;
      }
      return this.forgotPassword ? 1 : 0;
    },
  },

  methods: {
    reset() {
      this.email = null;
      this.password = null;
      this.forgotPassword = false;
      this.passwordRequested = false;
    },

    async requestNewPassword() {
      if (!this.validEmail) { return; }

      const resetPasswordInput = { email: this.email };
      const mutation = this.$mutations.resetPassword;
      this.$mutate(mutation, { resetPasswordInput });
      this.passwordRequested = true;
    },

    async submitLogin() {
      const formIsValid = await this.$validator.validate();

      if (!formIsValid) {
        return;
      }

      await this.login(this.email, this.password);
    },
  },
};
</script>
